// @flow

import {browserHistory} from 'react-router';
import {POLICIES_API, PROCEDURES_API_URL} from 'app/urls';
import {get} from 'app/utils/request';
import {getPathFromURL} from 'app/utils/urls';
import type {KbQuestionType} from 'app/kbs/types';

export function goToArticleDocEditURL(
  article: KbQuestionType
): Promise<string> {
  const {document_content_type, document_object_id} = article;
  const id = document_object_id;
  const ct = document_content_type;

  return new Promise((resolve, reject) => {
    const baseURL =
      ct === 'procedure'
        ? PROCEDURES_API_URL
        : ct === 'policy'
        ? POLICIES_API
        : null;

    if (baseURL == null) {
      return reject(Error(`Invalid ct: ${ct}`));
    }

    get(`${baseURL}${id}`).then(
      (response) => resolve(getPathFromURL(`${response.html_url}edit/`)),
      reject
    );
  }).then(browserHistory.push);
}
